import React from 'react';
import { Provider } from 'react-redux';
import store from './store';
import RoutesContainer from './routes';
import './App.css';

function App() {
  return (
    <Provider store={store}>
      <RoutesContainer />
    </Provider>
  );
}

export default App;
